import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import UploadPage from './pages/UploadPage';
import AnatomicalMeasurementsPage from './pages/AnatomicalMeasurementsPage';
import AlignmentPage from './pages/AlignmentPage';
import PlanningPage from './pages/PlanningPage';
import HistoryPage from './pages/HistoryPage';
import SettingsPage from './pages/SettingsPage';


function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <div className="app-shell">
                <Header />
                {/* app-main is the scroll container — pages rely on it */}
                <main className="app-main">
                <Routes>
                  <Route path="/" element={<UploadPage />} />
                  <Route path="/measurements" element={<AnatomicalMeasurementsPage />} />
                  <Route path="/alignment" element={<AlignmentPage />} />
                  <Route path="/planning" element={<PlanningPage />} />
                  <Route path="/history" element={<HistoryPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  {/* Admin dashboard now lives inside Settings; keep old
                      links (e.g. from notification emails) working. */}
                  <Route path="/admin" element={<Navigate to="/settings?tab=access" replace />} />
                  {/* Unknown paths land on Upload instead of a blank shell */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                </main>
              </div>
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;